import type { OpsOrbAnalyserSnapshot } from "./ops-orb-analyser-store.js";

const OPS_REALTIME_OUTPUT_PRODUCER_PREFIX = "ops-realtime-output:";

/**
 * WHY [BOL-ORB-OUTPUT-ONLY-004]: The capture analyser exists to keep the
 * microphone worklet pulled, not to impersonate Luna. Passing that analyser to
 * the Orb made the avatar swell to the user's voice. Only the analyser attached
 * to physically scheduled Aoede output may unlock speech-scale motion; every
 * other producer leaves the canonical small idle breath in control.
 * Falsifier: speaking into the microphone changes the Orb radius, or audible
 * Luna output no longer reaches the renderer.
 */
export function selectOpsOrbOutputAnalyser(
  snapshot: OpsOrbAnalyserSnapshot
): AnalyserNode | null {
  return snapshot.producerLabel?.startsWith(OPS_REALTIME_OUTPUT_PRODUCER_PREFIX)
    ? snapshot.analyser
    : null;
}
